import * as React from "react";
import * as ReactDOM from "react-dom";
import "./tooltip.scss";
import { Icon } from '@iconify/react';

// interface to declare all our prop types
interface Props {
  children: React.ReactNode;
}

const InfoTooltip:  React.FC<Props> = ({ 
  children,
  ...rest
}) => {
    return (
      <div className="infoTooltipWrap">
          <Icon icon="ant-design:info-circle-outlined" />
          <div className="tooltipData">
            {children}
          </div>
      </div>
    );
  }

  export default InfoTooltip


